query OrganizationsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: OrganizationsFilterInput
) {
  organizations(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title
      altNames
      description
      slug
      website
      status
      logo {
        id
        url
      }
      createdAt
    }
    count
  }
}
